import { h, Component } from 'preact';
import * as BaseComp from 'components/bolt/countdown/countdown.js';

export default class Countdown extends BaseComp.default {
	render(props, state) {
		console.log();
		const { counting } = state;
		if (!counting || new Date(props.datetime) < new Date()) {
			return null;
		}
		return super.render(props, state);
	}
}
